import styled from 'styled-components';

interface SelectProps {
  hasError?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const getSizeStyles = (size: string = 'medium') => {
  switch (size) {
    case 'small':
      return `
        padding: 8px 12px;
        font-size: 0.875rem;
      `;
    case 'large':
      return `
        padding: 16px 20px;
        font-size: 1.1rem;
      `;
    default:
      return `
        padding: 12px 16px;
        font-size: 0.95rem;
      `;
  }
};

export const Select = styled.select<SelectProps>`
  ${props => getSizeStyles(props.size)}
  border: 2px solid ${props => props.hasError ? '#dc2626' : '#e1e8ed'};
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%236b7280'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px 16px;
  padding-right: 40px;
  
  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#dc2626' : '#667eea'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(220, 38, 38, 0.1)' : 'rgba(102, 126, 234, 0.1)'};
  }
  
  &:disabled {
    background: #f3f4f6;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// Custom select button for more complex select components
export const SelectButton = styled.button<{ hasValue?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  font-size: 0.95rem;
  text-align: left;
  transition: border-color 0.2s ease;
  color: ${props => props.hasValue ? '#374151' : '#9ca3af'};
  width: 100%;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &:hover {
    border-color: #9ca3af;
  }
`;

export const SelectIcon = styled.span`
  color: #6b7280;
  font-size: 0.75rem;
`;
